import React from 'react';
import { Button, Row, Col, Typography, Card, Divider } from 'antd';
import { ArrowLeftOutlined, PlusOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import CustomButton from '../Button/Button';

const { Title } = Typography;

interface GeneralContainerProps {
  title: string;
  actionLabel?: string;
  onActionClick?: () => void;
  isGoBack?: boolean;
  children: React.ReactNode;
  isLoading?: boolean;
  extra?: React.ReactNode;
}

const GeneralContainer: React.FC<GeneralContainerProps> = ({
  title,
  actionLabel,
  onActionClick,
  isGoBack = false,
  children,
  isLoading = false,
  extra,
}) => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
   <Card className="general-container">
    <Row
      justify="space-between"
      align="middle"
      gutter={[8, 16]}
      style={{ flexWrap: 'wrap' }}
    >
      {isGoBack && (
        <Col xs={24} sm="auto" style={{ marginBottom: 8 }}>
          <Button
            variant="filled"
            icon={<ArrowLeftOutlined />}
            onClick={handleGoBack}
            size="large"
            block
          >
            Volver
          </Button>
        </Col>
      )}
      <Col xs={24} sm="auto" flex="auto" className="container-title" style={{ marginBottom: 8 }}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 8,
          }}
        >
          <Title level={3} style={{ margin: 0 }}>{title}</Title>
          {extra}
        </div>
      </Col>
      {actionLabel && onActionClick && (
        <Col sm="auto" style={{ marginBottom: 8, textAlign: 'right' }}>
          <CustomButton
            disabled={isLoading}
            icon={<PlusOutlined />}
            label={actionLabel}
            onClick={onActionClick}
            size="large"
            block
          />
        </Col>
      )}
    </Row>
    <div>{children}</div>
  </Card>
  );
};

export default GeneralContainer;
